import { Drawer, DrawerContent, DrawerTitle } from "@mylaunch/components/ui"
import { Button } from "~/components/ui/button"
import { AsyncButton } from "~/components/ui/async-button"
import { subscribeToPush } from "../lib/subscribe-push"

interface Props {
  open: boolean
  onClose: () => void
}

export function PermissionDrawer({ open, onClose }: Props) {
  return (
    <Drawer open={open} onOpenChange={(o) => !o && onClose()}>
      <DrawerContent handle={false} className="bg-white border-0 shadow-none">
        <DrawerTitle className="sr-only">Присылать уведомления?</DrawerTitle>
        <div className="flex flex-col gap-m p-m">
          <div lang="ru" className="font-bold text-xl hyphens-auto">Присылать уведомления?</div>
          <p lang="ru" className="text-base text-muted-foreground hyphens-auto">
            Только полезные новости и напоминания о событиях.
          </p>
          <AsyncButton
            size="lg"
            fn={async () => { await subscribeToPush() }}
            onSuccess={onClose}
            errorMessage="Не удалось включить уведомления"
          >
            Да
          </AsyncButton>
          <Button size="lg" variant="ghost" onClick={onClose}>Нет</Button>
        </div>
      </DrawerContent>
    </Drawer>
  )
}
